import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectChangeEvent, SelectModule } from 'primeng/select';

import { CheckboxModule } from 'primeng/checkbox';
import { ChipInformationForm } from '@app/models/chip.model';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabel } from "primeng/floatlabel";
import { InputTextModule } from 'primeng/inputtext';
import { TranslatePipe } from '@ngx-translate/core';
import { Veterinarian } from '@app/pages/clinic/models/clinic.model';

@Component({
    selector: 'app-chip-info-form',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    InputTextModule,
    SelectModule,
    DatePickerModule,
    CheckboxModule,
    FloatLabel
],
    templateUrl: './chip-info-form.component.html',
    styleUrl: './chip-info-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipInfoFormComponent {
    readonly formGroup = input.required<FormGroup<ChipInformationForm>>();
    readonly vets = input.required<Veterinarian[]>();
    readonly isRegistration = input<boolean>(true);

    changeVeterinarian({value: vetId}: SelectChangeEvent): void {
        if (vetId) {
            this.formGroup()
                .get('selectedVetDocumentId')
                ?.setValue(this.vets().find((vet) => vet.id === vetId)?.veterinaryId || '');
        }
    }
}
